<template>
  <div :class="{ 'flex items-center between': variant === 'inline' }">
    <p class="text-xs">
      {{ message }}
      <span class="sr-only">Klarna</span>
      <vf-icon
        v-if="variant === 'inline'"
        :height="imageHeight"
        src="/img/logos/klarna.svg"
        style="display: inline-block; vertical-align: baseline"
        :width="imageWidth"
      />
    </p>
    <vf-icon
      v-if="variant !== 'inline'"
      :height="imageHeight"
      src="/img/logos/klarna.svg"
      style="display: inline-block; vertical-align: baseline"
      :width="imageWidth"
    />
    <base-button
      class="ml-2 ws-nowrap text-sm underlined lh-3"
      @click="DialogKlarna.keep().open({ currency, installmentPrice, isInThreshold })"
    >
      {{ $t.klarnaPayments.learnMore }}
    </base-button>
    <p v-if="$t.klarnaPayments.disclaimerText" class="text-xs lh-3">
      {{ $t.klarnaPayments.disclaimerText }}
    </p>
  </div>
</template>

<script lang="ts" setup>
const props = defineProps<{
  currency: string
  price: number
  variant?: 'inline'
}>()

const { $locale, $t } = useNuxtApp()
const { DialogKlarna } = useDialogsStore()

// App configs used inside computed function leak memory
// This clones the config to break the reactivity and fix the leak
// A better solution is probably available by looking deeper into the app configs
const { imageHeight, imageWidth, installments: installmentsConfig, maxThreshold, minThreshold } = {
  ...useAppConfig().components?.klarna
}
const installments = installmentsConfig[$locale] || installmentsConfig.default

const installmentPrice = computed(() => {
  const installment = props.price / (installments)
  return Math.ceil(installment * 100) / 100
})

const isInThreshold = computed(() => props.price > minThreshold && props.price < maxThreshold)

const message = computed(() => replaceAll(
  isInThreshold.value ? $t.klarnaPayments.inThreshold : $t.klarnaPayments.belowThreshold,
  {
    amount: useFormattedPrice(installmentPrice.value, props.currency),
    max: useFormattedPrice(maxThreshold, props.currency),
    min: useFormattedPrice(minThreshold, props.currency),
    installments
  }
))
</script>
